module.exports = __webpack_public_path__ + "img/cam_2_on.78e68a2a.png";